/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { BuilderButlRoutingModule } from './builder-butl-routing.module';
import { ButlListComponent } from './components/butl-list/butl-list.component';
import { ButlListBusinessService } from './resources/butl-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderButlRoutingModule,
  ],
  providers: [
    ButlListBusinessService,
  ],
  declarations: [
    ButlListComponent,
  ],
})

export class BuilderButlModule {
}
